import { Dispatch, memo } from 'react';
import { useDispatch } from 'react-redux';

import { DATE_FORMAT_SHORT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IAttachment } from 'APIPackage/NewsModule/interfaces/IAttachment';
import { INews } from 'APIPackage/NewsModule/interfaces/INews';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { AccordionWithButton } from 'UIPackage/MainModule/components/AccordionWithButton';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import styles from './NewsItem.module.scss';
import { newsGetAttachmentNews } from '../actions/newsActions';

export const NewsItem = memo(({ id, published, title, text, shortText, attachments }: INews) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const makeFileDownloadHandler = (file: IAttachment) => async () => {
    if (attachments?.length) {
      dispatch(newsGetAttachmentNews(id, file));
    }
  };

  return (
    <article>
      <h4 className={styles.Title}>{title}</h4>
      <div className={styles.Date}>{formatDate({ date: published, dateFormat: DATE_FORMAT_SHORT_FNS })}</div>
      <p className={styles.Text}>{shortText}</p>
      {text && <AccordionWithButton content={text.split('&lt;').join('<').split('&gt;').join('>')} />}
      {attachments &&
        attachments.length !== 0 &&
        attachments.map(attachment => (
          <div key={attachment.id} className={styles.FileBlock}>
            <div className={styles.FileImg} />
            <div className={styles.FileText}>
              <span className={styles.FileLink} onClick={makeFileDownloadHandler(attachment)}>
                {attachment.name}
              </span>
            </div>
          </div>
        ))}
    </article>
  );
});
